<template>
  <tr
    v-sync-rows-height:[applySync]
    class="simple-comparison-row"
    :class="{
      'data-no-border': noBorder,
      'data-no-padding-top': noPaddingTop,
      'data-no-padding-bottom': noPaddingBottom,
      [index % 2 === 1 ? 'even-row' : 'odd-row']: true,
      syncscroll: true,
    }"
  >
    <th
        class="simple-comparison-row__label"
        :class="{'no-border': noHighlight, [index % 2 === 1 ? 'even' : 'odd']: true}"
    >
      <template v-if="index === 0">
        <label
            class="checkbox-label"
            for="same-brand-checkbox"
            @click="simpleComparison.toggleSameBrand()"
        >
          <CustomCheckbox id="same-brand-checkbox" name="same-brand" :checked="simpleComparison.sameBrand" />
          <span @click.prevent>{{ $t('product.comparison.same_brand_only') }}</span>
        </label>
      </template>
      <template v-else>{{ data.label }}</template>
    </th>
    <component
      v-for="(column, i) of data.columns"
      :key="i"
      :is="index === 0 ? 'th' : 'td'"
      class="similar-comparison-data"
      :class="{
        'similar-comparison-data-first': i === 0 && !noHighlight,
        [index % 2 === 1 ? 'even' : 'odd']: true,
      }"
    >
      <slot :column-data="column" :index="i">
        <ProductBadge :uid="Math.random()" v-if="column.value" :label="{name: formatValue(column.value), slug: '', description: ''}"/>
      </slot>
    </component>

    <td
      v-for="(slotIndex, k) of numberProducts - data.columns.length"
      :key="'empty-slot' + k"
      class="similar-comparison-data simple-comaprison-data__empty-slot"
    >
      <slot name="emptySlot" />
    </td>
  </tr>
</template>

<script setup>
import CustomCheckbox from '@/components/core/CustomCheckbox';
import syncRowsHeight from '@/directives/syncRowsHeight';
import ProductBadge from '~/components/core/ProductBadge';
import { useSimpleComparisonStore } from "~/stores/simpleComparison";

const vSyncRowsHeight = syncRowsHeight;

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  applySync: {
    type: Boolean,
    default: false,
  },
  numberProducts: {
    type: Number,
    default: 5,
  },
  numberProductsMobile: {
    type: Number,
    default: 2,
  },
  noBorder: {
    type: Boolean,
    default: false,
  },
  noPaddingTop: {
    type: Boolean,
    default: false,
  },
  noPaddingBottom: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  index: {
    type: Number,
    default: 0,
  },
  noHighlight: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n();

const simpleComparison = useSimpleComparisonStore();
function formatValue(value) {
  if (value === 'No' || value === t('generic.no')) {
    // return '&#10005;';
    return '&#45;';
  }
  if (value === 'Yes' || value === t('generic.yes')) {
    return '&#10003;';
  }
  return value;
}
</script>

<style lang="scss" scoped>
%small-grey-bold {
  font-size: 12px;
  color: #777777;
  font-weight: bold;
}
.simple-comparison-row {
  display: flex;
  align-items: stretch;

  @media (max-width: $break_xs_under) {
    width: 100%;
    overflow: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .current-product-label {
    display: block;
    @extend %small-grey-bold;
  }

  .similar-comparison-data {
    position: relative;
    .similar-comparison-data-header {
      font-weight: bold;
      height: 23px;
      white-space: nowrap;
    }
    .similar-msg-container {
      min-height: 45px;
      margin: 30px 0;
      .similar-msg {
        @extend %small-grey-bold;
      }
    }
    :deep() {
      .star-rating {
        position: relative;
        top: 1px;
      }
    }
  }

  .simple-comparison-row__label,
  .similar-comparison-data,
  .simple-comaprison-data__empty-slot {
    width: 25%;
    padding: 0.7rem 0.5rem;
    min-width: 12rem;
    font-weight: 300;
    display: flex;
  }

  .simple-comparison-row__label {
    display: flex;
    align-items: center;
    min-width: 100px;

    label.checkbox-label {
      display: flex;
      align-items: center;
      height: 100%;
      font-size: 14px;
      font-weight: 300;

      :deep() {
        span.checkbox {
          height: 24px;
          width: 24px;
          margin-right: 4px;
        }
      }
    }
  }

  .simple-comparison-row__label, .similar-comparison-data {
    background-color: #fff;
  }
  .simple-comparison-row__label.even,
  .similar-comparison-data.even {
    //background-color: #f8f8f8;
  }
  .simple-comaprison-data__empty-slot {
    // height: 163px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    span {
      display: inline-block;
      margin-top: 15px;
      text-align: center;
    }
  }
}
</style>
